import request from '../utils/request';
// 发送验证码--忘记密码专用
export function getVerifyCode(data) {
	return request({
		url: '/user/forget_password_send_verify_code',
		method: 'post',
		data,
	});
}
// /user/terminal_login
export function terminalLogin(data) {
	return request({
		url: '/user/terminal_login',
		method: 'post',
		data,
	});
}
// /user/send_verify_code
export function sendVerifyCode(data) {
	return request({
		url: '/user/send_verify_code',
		method: 'post',
		data,
	});
}
// /user/login 密码登录
export function login(data) {
	return request({
		url: '/user/pc_login',
		method: 'post',
		data,
	});
}
// /user/pc_terminal_register 手机注册
export function terminalRegister(data) {
	return request({
		url: '/user/pc_terminal_register',
		method: 'post',
		data,
	});
}

// 测试api /test/test_decode
export function test(data) {
	return request({
		url: '/test/test_decode',
		method: 'post',
		data,
	});
}
// /app/create_ft_key 申请临时加密秘钥-网页用
export function key(data) {
	return request({
		url: '/app/create_ft_key',
		method: 'post',
		data,
	});
}
// 忘记账号密码查询绑定手机号 /user/pc_query_phone
export function queryPhone(data) {
	return request({
		url: '/user/pc_query_phone',
		method: 'post',
		data,
	});
}

// /user/forget_password_modify 忘记密码 /pc_forget_password
export function forgetPassword(data) {
	return request({
		url: '/user/pc_forget_password',
		method: 'post',
		data,
	});
}

// 请求二维码 /user/pc_refresh_qr_code
export function refresh_qr_code(data) {
	return request({
		url: '/user/pc_refresh_qr_code',
		method: 'post',
		data,
	});
}
// /user/pc_query_result 查询结果=>user/pc_query_qr_code
export function query_result(data) {
	return request({
		url: 'user/pc_query_qr_code',
		method: 'post',
		data,
	});
}

// 实名认证绑定 /identity/bind
export function bindID(data) {
	return request({
		url: 'identity/bind',
		method: 'post',
		data,
	});
}
// /user/forget_password_verify_code 忘记密码_效验验证码
export function forget_password_verify_code(data) {
	return request({
		url: 'user/forget_password_verify_code',
		method: 'post',
		data,
	});
}
// /bind_phone /user/bind_phone
export function bindPhone(data) {
	return request({
		url: '/user/bind_phone',
		method: 'post',
		data,
	});
}
// /user/bind_email
export function bindEmail(data) {
	return request({
		url: '/user/bind_email',
		method: 'post',
		data,
	});
}
//   /user/check_unbind 查询解绑状态信息
export function checkUnbind(data) {
	return request({
		url: '/user/check_unbind',
		method: 'post',
		data,
	});
}

//   /user/unbind_phone
export function unbindPhone(data) {
	return request({
		url: '/user/unbind_phone',
		method: 'post',
		data,
	});
}

// /user/unbind_email
export function unbindEmail(data) {
	return request({
		url: '/user/unbind_email',
		method: 'post',
		data,
	});
}
// /user/change_terminal
export function changeTerminal(data) {
	return request({
		url: '/user/change_terminal',
		method: 'post',
		data,
	});
}
// /user/check_terminal
export function checkTerminal(data) {
	return request({
		url: '/user/check_terminal',
		method: 'post',
		data,
	});
}
// /user/change_terminal
// export function changeTerminal (data) {
//   return request({
//     url: "/user/change_terminal",
//     method: "post",
//     data,
//   });
// }
// /user/bind_terminal
export function bindTerminal(data) {
	return request({
		url: '/user/bind_terminal',
		method: 'post',
		data,
	});
}
// /user/del_user_token 获取注销token
export function del_user_token(data) {
	return request({
		url: '/user/del_user_token',
		method: 'post',
		data,
	});
}

// /user/query_del_submit_enable
export function query_del_submit_enable(data) {
	return request({
		url: '/user/query_del_submit_enable',
		method: 'post',
		data,
	});
}
// /user/verify_terminal 绑定账号
export function verify_terminal(data) {
	return request({
		url: '/user/verify_terminal',
		method: 'post',
		data,
	});
}

// 引继码查询 /user/preamble_code_check
export function preamble_code_check(data) {
	return request({
		url: '/user/preamble_code_check',
		method: 'post',
		data,
	});
}

// 引继码迁移 /user/preamble_code_transfer
export function preamble_code_transfer(data) {
	return request({
		url: '/user/preamble_code_transfer',
		method: 'post',
		data,
	});
}

// 设置引继码密码 /user/set_preamble_code_password
export function set_preamble_code_password(data) {
	return request({
		url: '/user/set_preamble_code_password',
		method: 'post',
		data,
	});
}

// 查看引继码 /user/preamble_code
export function preamble_code(data) {
	return request({
		url: '/user/preamble_code',
		method: 'post',
		data,
	});
}
// 游客登录/user/get_user_by_udid
export function get_user_by_udid(data) {
	return request({
		url: '/user/get_user_by_udid',
		method: 'post',
		data,
	});
}
